export const deviceSelect = function () {
  return {
    selection: true,
    page: true,
    index: true,
    indexLabel: "序号",
    column: [
      {
        label: "设备名称",
        prop: "deviceName",
        clearable: true
      }
    ]
  };
};
